(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const burgerBtn = document.getElementById('burgerBtn');
const navMenu = document.getElementById('navMenu');

burgerBtn.addEventListener('click', () => {
  navMenu.classList.toggle('open');
  burgerBtn.classList.toggle('active');
});

document.querySelectorAll('.nav-item').forEach(item => {
  item.addEventListener('click', () => {
    navMenu.classList.remove('open');
    burgerBtn.classList.remove('active');
  });
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('header')) {
    navMenu.classList.remove('open');
    burgerBtn.classList.remove('active');
  }
});

  } catch(e) { console.error(e); }
})();
})();
